import { BackDropAction } from "../../actions/components/BackDropAction";

export interface BackDropState {
  open: boolean;
}

const initialState = {
  open: false,
};

export function BackDropReducer(
  state: BackDropState = initialState,
  action: BackDropAction
): BackDropState {
  switch (action.type) {
    case "BACK_DROP_OPEN":
      return {
        ...state,
        open: true,
      };
    case "BACK_DROP_CLOSE":
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}
